export default "__VITE_ASSET__DXR9l3vc__"